import React from 'react'

export default function PageTitle({title}) {
  return (
    <h1 className='page_title'>{title}</h1>
  )
}
